<template>
  <div>
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">E-mail signature</h3>
        <p class="mt-5 mb-6">
          Configure your signature below. This signature will be included in
          every mail you send from the Engage Email module.
        </p>
      </vs-col>
    </vs-row>

    <div v-if="!emailSignature">
      <p>You have not created an e-mail signature yet.</p>
      <vs-button @click="createSignature" class="mt-2"
        >Create signature</vs-button
      >
    </div>

    <vx-card no-shadow v-if="emailSignature">
      <div class="vx-row mb-6 mt-3">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Signature</span>
        </div>
        <div class="vx-col">
          <p>My signature</p>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Enabled</span>
        </div>
        <div class="vx-col">
          <vs-switch color="success" v-model="emailSignature.enabled" />
        </div>
      </div>

      <div id="toolbar" v-if="!htmlMode">
        <span class="ql-formats">
          <button class="ql-list" value="ordered"></button>
          <button class="ql-list" value="bullet"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-header" defaultValue="">
            <option value="1"></option>
            <option value="2"></option>
            <option value="3"></option>
            <option value=""></option>
          </select>
          <select class="ql-font" defaultValue=""></select>
          <select class="ql-size" defaultValue="">
            <option value="small"></option>
            <option value=""></option>
            <option value="large"></option>
            <option value="huge"></option>
          </select>
        </span>
        <span class="ql-formats">
          <button class="ql-indent" value="-1"></button>
          <button class="ql-indent" value="+1"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-bold"></button>
          <button class="ql-italic"></button>
          <button class="ql-underline"></button>
          <button class="ql-strike"></button>
          <button class="ql-blockquote"></button>
          <button class="ql-code-block"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-placeholder">
            <option v-for="ph in placeholders" :key="ph.id" :value="ph.label">
              {{ ph.name }}
            </option>
          </select>
        </span>
      </div>
      <quill-editor
        v-if="!htmlMode"
        class="editor"
        v-model="emailSignature.htmlContent"
        :options="editorOption"
      ></quill-editor>

      <div class="vx-row" v-if="htmlMode">
        <div class="vx-col sm:w-1/5 w-full">
          <span>HTML</span>
        </div>
        <div class="vx-col w-full">
          <vs-textarea
            rows="8"
            label="HTML content"
            v-model="emailSignature.htmlContent"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <div class="cursor-pointer" @click="htmlMode = !htmlMode">
            <span style="color: blue">Toggle HTML mode</span>
          </div>
        </div>
      </div>

      <!-- Save & Remove Button -->
      <vs-row
        vs-justify="space-between"
        class="flex flex-wrap items-center"
        style="margin-top: 32px"
      >
        <vs-button id="save-button" @click="update" class="mt-2"
          >Save Changes</vs-button
        >
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import "quill-mention";

import { quillEditor } from "vue-quill-editor";

import Quill from "quill";
import PlaceholderModule from "quill-placeholder-module";
Quill.register("modules/placeholder", PlaceholderModule(Quill));

export default {
  components: { quillEditor },
  data() {
    return { htmlMode: false };
  },
  methods: {
    async createSignature() {
      this.$vs.loading();

      try {
        console.log("Creating new signature");
        await this.$store.dispatch("email/createEmailSignature");

        this.$vs.notify({
          color: "green",
          title: "Created",
          text: "Created",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Error creating",
          text: "Error creating",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async update() {
      this.$vs.loading();

      try {
        console.log("Updating", this.emailSignature);
        await this.$store.dispatch(
          "email/updateEmailSignature",
          this.emailSignature
        );

        this.$vs.notify({
          color: "green",
          title: "Saved",
          text: "Saved",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Error saving",
          text: "Error saving",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  computed: {
    ...mapGetters({
      emailSignature: "email/emailSignature",
      hasEmailSignature: "email/hasEmailSignature",
    }),
    editorOption() {
      return {
        modules: {
          toolbar: { container: `#toolbar` },
          placeholder: {
            delimiters: ["{{", "}}"], // default
            placeholders: this.placeholders,
          },
        },
        placeholder: "",
        theme: "snow", // or 'bubble'
      };
    },
    placeholders() {
      return this.$store.getters["handlebars/getFor"]("venue", "user").map(
        (e) => {
          console.log("hm", e);
          return {
            id: e.handlebar,
            name: e.name,
            label: e.handlebar,
          };
        }
      );
    },
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("email/getEmailSignature");
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
.ql-picker.ql-placeholder {
  width: 118px;
}

.ql-picker.ql-placeholder > span.ql-picker-label::before {
  content: "Placeholders";
}

.ql-picker.ql-placeholder
  > span.ql-picker-options
  > span.ql-picker-item::before {
  content: attr(data-label);
}
</style>

<style lang="scss" scoped>
.vx-card {
  overflow: scroll;
}
</style>